// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
import * as helper from './../../../../../VX/View/Assets/Js/helper';
import {initImprint} from "../../../Assets/JS/imprint_la";

require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
require('babel-polyfill');

helper.onDocumentLoaded(() => {
	initImprint(helper.$('#impressumlink'), helper.$('#datenschutzlink'));

	const width = window.innerWidth;

	const container = helper.$('#container');
	const nextButtons: HTMLDivElement[] = helper.$('a.next');
	const desktopGirls: HTMLDivElement[] = helper.$('.desktop .girl');
	const phoneGirls: HTMLDivElement[] = helper.$('.phone .girl');
	const steps: HTMLDivElement[] = helper.$('div.step');

	const url1 = helper.getData(container, 'url1');
	const url2 = helper.getData(container, 'url2');

	const ab3 = parseInt(helper.getData(container, 'ab3'));

	let current = 0;
	(steps[current].querySelector('.step__footer .btn') as HTMLAnchorElement).style.opacity = '1';

	nextButtons.forEach((button) => {
		helper.addEventListener(button, 'click', async (e: MouseEvent) => {
			e.preventDefault();

			if (current === steps.length - 1) {
				window.open(url1);
				window.location.href = url2;
				return;
			}

			const currentStep: HTMLDivElement = steps[current];
			const currentDesktopGirl = desktopGirls[current];
			const currentPhoneGirl = phoneGirls[current];

			current++;

			const nextStep = steps[current];
			const nextDesktopGirl = desktopGirls[current];
			const nextPhoneGirl = phoneGirls[current];

			if (width > 1023) {
				await helper.fadeOutAll(currentStep.querySelectorAll('.step__inner > div'));
			} else {
				if (ab3 === 0) {
					helper.removeClass(currentStep, 'active');
				}
			}

			if (ab3 === 0) {
				helper.addClass(container, 'open');
				await helper.wait(1)
			}

			if (ab3 === 1) {
				await helper.fadeOutAll(currentStep.querySelectorAll('.step__footer .btn'), 300);
			}

			helper.removeClass(currentDesktopGirl, 'active');
			helper.removeClass(currentPhoneGirl, 'active');
			helper.removeClass(currentStep, 'active');
			if (width > 1023) {
				helper.fadeOutAll(nextStep.querySelectorAll('.step__inner > div'), 0)
			}

			helper.addClass(nextDesktopGirl, 'active');
			helper.addClass(nextPhoneGirl, 'active');
			helper.addClass(nextStep, 'active');
			helper.removeClass(container, 'open')

			if (ab3 === 1) {
				await helper.fadeInAll(nextStep.querySelectorAll('.step__footer .btn'), 300);
			}

			await helper.wait(0.4)
			if (width > 1023) {
				helper.fadeInAll(nextStep.querySelectorAll('.step__inner > div'), 400)
			}
		})
	})
})
